import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './accessControlModel';
import { RootStoreType } from '../rootReducer';
import { AccessesToModelsDto } from '../../@shared/Models/AccessModels';
import { User } from '../../@shared/Models/Models';

const statesSlice = createSlice({
    name: 'accessControlReducer',
    initialState: initialState.accessControlModel,
    reducers: {
        setOpenedAccessModelId: (state, action: PayloadAction<string>) => {
            state.openedAccessModelId = action.payload;
        },
        setIsShowAccessModal: (state, action: PayloadAction<boolean>) => {
            state.isShowAccessModal = action.payload;
        },
        setIsShowLoader: (state, action: PayloadAction<boolean>) => {
            state.isShowLoader = action.payload;
        },
        setAccessList: (state, action: PayloadAction<AccessesToModelsDto[]>) => {
            state.list = action.payload;
        },
        setSearchedUsers: (state, action: PayloadAction<User[]>) => {
            state.searchedUsers = action.payload;
        }
    }
});

export const {
    setOpenedAccessModelId,
    setIsShowAccessModal,
    setIsShowLoader,
    setAccessList,
    setSearchedUsers
} = statesSlice.actions;

//selectors
export const getOpenedAccessModelId = (store: RootStoreType): string => store.access.accessControlModel.openedAccessModelId;
export const getIsShowAccessModal = (store: RootStoreType): boolean => store.access.accessControlModel.isShowAccessModal;
export const getIsShowLoader = (store: RootStoreType): boolean => store.access.accessControlModel.isShowLoader;
export const getAccessList = (store: RootStoreType): AccessesToModelsDto[] => store.access.accessControlModel.list;
export const getSearchedUsers = (store: RootStoreType): User[] => store.access.accessControlModel.searchedUsers;

export default statesSlice.reducer;